import { useEffect, RefObject } from "react";

export default function useClickedOutside(
  ref: RefObject<HTMLElement>,
  onClickedOutside: () => void,
  disabled?: boolean,
): void {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (!disabled && !ref.current?.contains(event.target as Node)) {
        onClickedOutside();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, disabled]);
}
